export const addChoiceWizardText = {
  title: 'Add a question for your choice branch',
  inputTitle: 'Choice question',
  placeholder: 'Question',
  cancel: 'Cancel',
  accept: 'Accept',
};
